import normalizeCharacteristicSkillAdjs from './normalizeCharacteristicSkillAdjs'
import getCharacterArmourDexPen from './getCharacterArmourDexPen'

//--------------------------------------------------
// get effective characteristic skill adjustments
//--------------------------------------------------
export default function getEffectiveCharacteristicSkillAdjs(character = null) {
  if (!character) return []

  const existingAdjs = normalizeCharacteristicSkillAdjs(character.characteristic_skill_adjs)
  const retainedAdjs = existingAdjs.filter((adj) => adj.adj_armour !== true)
  const dexPen = getCharacterArmourDexPen(character)

  if (dexPen > 0) {
    const existingArmourAdj = existingAdjs.find((adj) => adj.adj_armour === true) || null

    retainedAdjs.push({
      id: existingArmourAdj?.id ?? null,
      name: 'dex',
      characteristic_name: 'dex',
      adj_value: -dexPen,
      adj_reason: 'Armour Dex penalty',
      adj_armour: true,
      character_item: existingArmourAdj?.character_item ?? null,
      applied: true,
      editable: false,
      rune: '',
      source: 'characteristic-skill',
    })
  }

  return retainedAdjs
}
